import ReactQuill from "react-quill-new";
import 'react-quill-new/dist/quill.snow.css';
import { doc, setDoc, getDoc } from "firebase/firestore";
import React, {useState, useEffect} from "react";
import { db } from "@/firebaseConfig.js";
import fetchContent from "@/utils/fetchContent.jsx";
import {Alert, Button} from "antd";

const FaqEdit = () => {

    const [content, setContent] = useState("");
    const [success, setSuccess] = useState(false);
    const [loading, setLoading] = useState(false);


    useEffect(() => {
        const loadContent = async () => {
            const data = await fetchContent("faq", "doc1");
            setContent(data);
        };

        loadContent();
    }, []);

    const saveContent = async () => {
        try {
            setLoading(true);
            await setDoc(doc(db, "faq", "doc1"), { content });
            setSuccess(true);
        } catch (error) {
            console.error("Ошибка при сохранении контента:", error);
            setSuccess(false);
        }finally {
            setLoading(false);
        }
    };


    return (
        <div className={  `wrapper`}>
            {success && (
                <Alert
                    message="Saved!"
                    type="success"
                    showIcon
                    closable
                    onClose={() => setSuccess(false)}
                />
            )}

            <div className={  `page page-app`}>
                <h2>FAQ</h2>
                <ReactQuill theme="snow" value={content} onChange={setContent} />
                <Button loading={loading} type={`primary`} onClick={saveContent}>Save</Button>
            </div>
        </div>
    );
};

export default FaqEdit;